module.exports = __webpack_public_path__ + "img/2.20d869f8.jpg";